import * as React from 'react';

import { ResponsiveSlider } from '../../components/ResponsiveSlider';
import { SliderCounter } from '../../components/SliderCounter';

export interface IResponsiveSliderContainerProps<TItem> {
  slides: TItem[];
  renderSlide: (item: TItem, index: number) => React.ReactNode;
  padding?: number;
}

export function ResponsiveSliderContainer<TItem>({
  slides,
  renderSlide,
  padding = 0,
}: IResponsiveSliderContainerProps<TItem>) {
  const renderedSlides = slides.map((slide, index) => renderSlide(slide, index));

  return (
    <ResponsiveSlider
      slides={renderedSlides}
      padding={padding}
      renderDots={({ currentSlide, totalSlides }) => <SliderCounter current={currentSlide + 1} total={totalSlides} />}
    />
  );
}
